export default __webpack_public_path__ + "static/media/bruce-hamilton-960.5239cc14.jpg";